export interface User {
    id: string;
    username: string;
    email: string;
    name: string;
}

export interface LoginCredentials {
    username: string;
    password: string;
}

export interface AuthResponse {
    success: boolean;
    user?: User;
    token?: string;
    error?: string;
}

const MOCK_USERS = [
    {
        id: '1',
        username: 'admin',
        password: 'password123',
        email: 'admin@demo.com',
        name: 'Admin User'
    }
];

class AuthService {
    private currentUser: User | null = null;
    private token: string | null = null;

    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        const { username, password } = credentials;

        const user = MOCK_USERS.find(
            u => u.username === username && u.password === password
        );

        if (!user) {
            return {
                success: false,
                error: 'Invalid username or password'
            };
        }

        const { password: _, ...userWithoutPassword } = user;
        this.currentUser = userWithoutPassword;
        this.token = this.generateToken();

        localStorage.setItem('auth_token', this.token);
        localStorage.setItem('current_user', JSON.stringify(this.currentUser));

        return {
            success: true,
            user: this.currentUser,
            token: this.token
        };
    }

    async logout(): Promise<void> {
        this.currentUser = null;
        this.token = null;
        localStorage.removeItem('auth_token');
        localStorage.removeItem('current_user');
    }

    getCurrentUser(): User | null {
        if (this.currentUser) {
            return this.currentUser;
        }

        const storedUser = localStorage.getItem('current_user');
        if (storedUser) {
            this.currentUser = JSON.parse(storedUser);
            return this.currentUser;
        }

        return null;
    }

    getToken(): string | null {
        if (this.token) {
            return this.token;
        }

        const storedToken = localStorage.getItem('auth_token');
        if (storedToken) {
            this.token = storedToken;
            return this.token;
        }

        return null;
    }

    isAuthenticated(): boolean {
        return !!this.getCurrentUser() && !!this.getToken();
    }

    private generateToken(): string {
        return 'mock_token_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
}

export const authService = new AuthService();
